export default async function mswStarterLogic() {
	// Only enable MSW in development environment
	const isDev = process.env.NODE_ENV === 'development';

	if (isDev && typeof window !== 'undefined') {
		if (window.location.pathname === '/clinical') {
			window.location.pathname = '/clinical/';
			return Promise.resolve();
		}
		const { worker } = await import('../mocks/browser');
		await worker.start({
			serviceWorker: {
				url: '/clinical/mockServiceWorker.js',
			},
		});
	}
	return Promise.resolve();
}
